import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CalendarOptions.scss';

class CalendarOptions extends Component {
  constructor(props) {
    super(props);
    const startDate = moment(props.startDate);
    const endDate = moment(props.startDate).add(startDate.daysInMonth() - 1, 'days');
    const startingWeekday = Number(startDate.format('d'));
    const endingWeekday = Number(endDate.format('d'));
    const calendarEndDate = moment(endDate).add(6 - endingWeekday, 'days');

    const weeksArray = [[]];
    const date = moment(props.startDate).subtract(startingWeekday, 'days');

    while (date.isSameOrBefore(calendarEndDate, 'day')) {
      if ((weeksArray[weeksArray.length - 1]).length === 7) {
        weeksArray[weeksArray.length] = [];
      }
      weeksArray[weeksArray.length - 1] = weeksArray[weeksArray.length - 1].concat(moment(date));
      date.add(1, 'days');
    }

    this.state = {
      monthLabel: startDate.format('MMMM YYYY'),
      weeksArray,
    };

    this.renderDay = this.renderDay.bind(this);
    this.renderWeek = this.renderWeek.bind(this);
  }

  renderDay(day) {
    const {
      availableDays, selectedDate, startDate, updateSelection, disabled,
    } = this.props;
    const date = Number(day.format('D'));
    const inCurrentMonth = (startDate.getMonth() === Number(day.month()));
    const available = inCurrentMonth && (availableDays.includes(date) ? 'available' : '');
    const selected = (inCurrentMonth && !disabled && selectedDate && (selectedDate.getDate() === day.date()) && (selectedDate.getMonth() === day.month())) ? 'selected' : '';
    const updateFunction = ((available && !disabled) ? updateSelection : () => {});

    return (
      <td role="gridcell" data-date={day} className={`${available} ${selected}`} onClick={updateFunction}>
        {date}
      </td>
    );
  }

  renderWeek(week) {
    return (
      <tr>
        {week.map((day) => this.renderDay(day))}
      </tr>
    );
  }

  render() {
    const { disabled } = this.props;
    const { monthLabel, weeksArray } = this.state;

    return (
      <table className={`calendar-table ${disabled ? 'disabled' : ''}`}>
        <thead>
          <tr>
            <th className="month-label" colSpan="7">{monthLabel}</th>
          </tr>
          <tr>
            <th>Su</th>
            <th>Mo</th>
            <th>Tu</th>
            <th>We</th>
            <th>Th</th>
            <th>Fr</th>
            <th>Sa</th>
          </tr>
        </thead>
        <tbody>
          {weeksArray.map((week) => this.renderWeek(week))}
        </tbody>
      </table>
    );
  }
}

CalendarOptions.propTypes = {
  startDate: PropTypes.shape({}).isRequired,
  availableDays: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectedDate: PropTypes.shape({}),
  updateSelection: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CalendarOptions.defaultProps = {
  selectedDate: new Date(),
  disabled: false,
};

export default CalendarOptions;
